import api from 'api/apiClient';
import { ensureFileArray } from 'modules/shared/service';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export const getWebsiteProjects = async () => {
  const { data: raw } = await unwrap(await api.get('/api/hr/website-sections'));

  const normalizedProject = raw.map((project) => {
    const builderContact = project.builder?.split('contact:')[1] ?? '';
    const builderName = project.builder?.split(' contact')[0] ?? '';

    const completionYear = new Date(project.completion_date).getFullYear();
    const status =
      project.status.split(' inProgressStatus:')[0] === 'Completed' ? 'completed' : 'in_progress';
    const inProgressStatus = project.status.split('inProgressStatus:')[1];

    return {
      id: project.id,
      title: project.title,
      projectType: project.project_type,
      location: project.location,
      completionYear,
      builderName,
      builderContact,
      description: project.description,
      area: project.area?.replace(/\.00|,/g, ''),
      status,
      inProgressStatus,
      tags: String(project.tags ?? '').split(', '),
      photos: project.photos,
    };
  });

  return normalizedProject;
};

const normalizeProjectPayload = async (project) => {
  const statusRaw = project.status;
  let status;
  if (statusRaw === 'completed') status = 'Completed';
  if (statusRaw === 'in_progress')
    status = `In Progress inProgressStatus:${project.inProgressStatus}`;

  const completionDate = new Date(project.completionYear, 0, 1);

  return {
    title: project.title,
    location: project.location,
    completion_date: completionDate.toISOString(),
    description: project.description,
    tags: project.tags.join(', '),
    photos: await ensureFileArray(project.photos),
    project_type: project.projectType,
    area: project.area,
    builder: `${project.builderName}${
      project.builderContact ? ` contact:${project.builderContact}` : ''
    }`,
    status: status,
  };
};

export const postWebsiteProject = async (project) => {
  if (!project) throw new Error('Missing project');
  const payload = await normalizeProjectPayload(project);

  await unwrap(await api.post('/api/hr/add-website-section', payload));
};

export const updateWebsiteProject = async (id, project) => {
  if (!id || !project) return;
  const payload = await normalizeProjectPayload(project);
  await unwrap(await api.put(`/api/hr/update-website-section/${id}`, { id, ...payload }));
};

export const deleteWebsiteProject = async (id) => {
  if (!id) return;
  await unwrap(await api.delete(`/api/hr/delete-website-section/${id}`));
};
